export default __webpack_public_path__ + "static/media/Ramo_Cover-400x482.0840de64.jpg";